import { render } from "./MigrateParticipant.vue?vue&type=template&id=765877bc&scoped=true"
import script from "./MigrateParticipant.vue?vue&type=script&lang=js"
export * from "./MigrateParticipant.vue?vue&type=script&lang=js"

import "./MigrateParticipant.vue?vue&type=style&index=0&id=765877bc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-765877bc"]])

export default __exports__